import { Link } from 'react-router-dom';

const quickLinks = [
  { to: '/', label: '首页' },
  { to: '/frontline', label: '围观前线' },
  { to: '/squad', label: '吃瓜小队' },
  { to: '/about', label: '关于我们' },
];

const categoryLinks = [
  { to: '/frontline?category=hot-trend', label: '网络热榜' },
  { to: '/frontline?category=live-scene', label: '娱乐现场' },
  { to: '/frontline?category=on-site', label: '活动现场' },
  { to: '/frontline?category=circle', label: '圈层动态' },
  { to: '/frontline?category=backstage', label: '幕后花絮' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-secondary-950">
                <i className="ri-seedling-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">511群众</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              511群众是一个抱团吃瓜的围观阵地。吃瓜小队把公开可见的现场见闻与热榜脉络整理成清晰的内容流，让你一眼跟上大家的关注点。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:hello@511qunzhong.space"
                rel="nofollow"
                aria-label="发送邮件"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-900 text-background-100 hover:bg-secondary-500 hover:text-secondary-950 transition-colors"
              >
                <i className="ri-mail-line"></i>
              </a>
              <Link
                to="/squad"
                aria-label="吃瓜小队"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-900 text-background-100 hover:bg-secondary-500 hover:text-secondary-950 transition-colors"
              >
                <i className="ri-team-line"></i>
              </Link>
              <Link
                to="/frontline"
                aria-label="围观前线"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-900 text-background-100 hover:bg-secondary-500 hover:text-secondary-950 transition-colors"
              >
                <i className="ri-radar-line"></i>
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <Link to="/frontline" className="hover:text-accent-300 transition-colors">
                站内导航
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-background-200 hover:text-accent-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <Link to="/frontline" className="hover:text-accent-300 transition-colors">
                主题分类
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-background-200 hover:text-accent-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-300">
          <p>© {new Date().getFullYear()} 511群众 · 抱团吃瓜，理智围观</p>
          <p>内容仅整理公开见闻，如有异议欢迎来信更正或下架</p>
        </div>
      </div>
    </footer>
  );
}